<template>
  <div style="width: 1024px;margin: auto;">
    <div style="display: flex;justify-content: center;margin-top: 50px;">
      <img class="img_shipinfangda" src="@/assets/shipinfangdawangcrop.jpg">
      <div class="div_intolink">
        <span style="font-size: 40px;font-weight: bold">视频放大网</span>
        <span style="margin-top: 20px;color: black ">人工智能AI超分辨率模型在线放大图片、视频  </span>
        <span style="margin-top: 20px;color: black "> 老照片色彩还原、老旧视频修复、高清4K重制</span>
        <span style="margin-top: 20px;color: black ">GPU运算后端,放大图像无需等待 </span>
        <span style="margin-top: 20px;color: black ">VIP会员限时特惠价¥199/年 </span>
        <a href="https://shipinfangda.com" target="_blank">
          <el-button style="margin-top: 20px;margin-left: 85px;margin-right: auto" type="success">点击进入</el-button>
        </a>
      </div>
    </div>

    <div style="display: flex;justify-content: center;margin-top: 13px;">
      <div style="display: flex;flex-direction: column;align-items: center">
        <img style="width: 144px" src="@/assets/wixinma.png">
        <span style="margin-top: 10px;color: black;font-weight: bold">放大网小程序已上线</span>
      </div>
      <div style="display: flex;flex-direction: column;align-items: center;margin-left: 230px" >
        <img style="width:144px" src="@/assets/gongzhonghao.jpg">
        <span style="margin-top: 10px;color: black;font-weight: bold">关注公众号获取更多信息</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "firstindex",
    methods: {}
  }
</script>

<style scoped lang="scss">
  .img_shipinfangda {
    width: 50%;
    height: 50%;
    max-width: 600px;
    max-height: 600px
  }

  .div_intolink {
    margin-top: 80px;
    margin-left: 5%;
    display: flex;
    flex-direction: column;
    max-width: 600px;
    max-height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/view/firstindex.vue